import { Component, OnInit, Input } from '@angular/core';
import {
  Router,
  Routes
} from '@angular/router';

import { Lagerplatz } from '../models/lagerplatz.model';

@Component({
  selector: 'sws-lagerplatzliste',
  templateUrl: './lagerplatzliste.component.html',
  styleUrls: ['./lagerplatzliste.component.css']
})
export class LagerplatzlisteComponent implements OnInit {
/**
   * @input gefundenePlaetze - die Lagerplatz[] - Liste die übergeben wurde
 */
  @Input() gefundenePlaetze: Lagerplatz[];


  constructor(private router: Router) {

   }

  ngOnInit() {
  }

 // Druck der angezeigten Artikelliste mit Beständen ----------------------------
 print(): void {
       let printContents, popupWin;
       printContents = document.getElementById('druckSection').innerHTML;
       popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
       popupWin.document.open();
       popupWin.document.write(`
          <html>
              <head>
                  <title>Liste Lagerbestand Seidler mit MHD</title>
                  <style>
                      
                  </style>
              </head>
              <body onload="window.print();window.close()">${printContents}
              </body>
          </html>`
       );
       popupWin.document.close();   
  }


}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/lagerplatzliste/lagerplatzliste.component.ts